import { render, staticRenderFns } from "./JobResources.vue?vue&type=template&id=60d7b469&"
import script from "./JobResources.vue?vue&type=script&lang=js&"
export * from "./JobResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports